"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _configuration = require("@jbrowse/core/configuration");

var _core = require("@material-ui/core");

var useStyles = (0, _core.makeStyles)(function () {
  return {
    importFormEntry: {
      minWidth: 180
    }
  };
});
var AssemblySelector = (0, _mobxReact.observer)(function (_ref) {
  var session = _ref.session,
      _onChange = _ref.onChange,
      selected = _ref.selected;
  var classes = useStyles();
  var assemblyNames = session.assemblyNames,
      assemblyManager = session.assemblyManager;
  var error = assemblyNames.length ? '' : 'No configured assemblies';
  return /*#__PURE__*/_react.default.createElement(_core.TextField, {
    select: true,
    label: "Assembly",
    variant: "outlined",
    margin: "normal",
    helperText: error || 'Select assembly to view',
    value: error ? '' : selected,
    inputProps: {
      'data-testid': 'assembly-selector'
    },
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    error: !!error,
    disabled: !!error,
    className: classes.importFormEntry
  }, assemblyNames.map(function (name) {
    var assembly = assemblyManager.get(name);
    var displayName = assembly ? (0, _configuration.getConf)(assembly, 'displayName') : '';
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: name,
      value: name
    }, displayName || name);
  }));
});
var _default = AssemblySelector;
exports.default = _default;